import { useBucket } from '@mc/experiments-react'
import { usePlansContext } from '@mc/plans-ui'
import { EXPERIMENT_FLAG, type ExperimentBucket } from '../constants'

// Gift flows are out of scope: the tier-mix baseline this experiment is
// measured against excludes gift orders, so including them here would report
// on a different population.
export const useExperiment = () => {
  const { isGift } = usePlansContext()
  const bucket = useBucket<ExperimentBucket>(EXPERIMENT_FLAG)

  const isOn = !isGift && !!bucket

  return {
    isOn,
    bucket: isOn ? bucket : undefined,
  }
}
